// extracted by mini-css-extract-plugin
module.exports = {"video":"videoURL-module--video--3Q891","buttonContainer":"videoURL-module--buttonContainer--3jebR","container":"videoURL-module--container--2TEGg"};